import { createSlice } from "@reduxjs/toolkit";
import {
  fetchProviderStatus,
  providerDuplicateCheck,
  updateProviderStatus,
} from "./ProviderStatusActions";
import { getApiErrorMessage } from "../../utils/commonUtilities";

const providerStatus = createSlice({
  name: "providerStatus",
  initialState: {
    isProviderStatusLoading: false,
    providerStatusData: [],
    providerStatusErrMsg: "",
    providerStatusError: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchProviderStatus.pending, (state) => {
        state.isProviderStatusLoading = true;
        state.providerStatusError = null;
      })
      .addCase(fetchProviderStatus.fulfilled, (state, action) => {
        if (!action.payload.success) {
          state.isProviderStatusLoading = false;
          state.providerStatusErrMsg = getApiErrorMessage(
            action.payload.success
          );
        } else {
          state.isProviderStatusLoading = false;
          state.providerStatusData = action.payload.data.data.providerStatusDto;
        }
      })
      .addCase(fetchProviderStatus.rejected, (state, action) => {
        state.isProviderStatusLoading = false;
        state.providerStatusError = action.error.message;
      });
  },
});

const providerStatusUpdate = createSlice({
  name: "providerStatusUpdate",
  initialState: {
    isProviderStatusLoading: false,
    providerStatusUpdateData: [],
    providerStatusMsg: "",
    providerStatusError: null,
    isDuplicateCheckLoading: false,
    isDuplicateCheckData: [],
    isDuplicateCheckError: null,
    isDuplicateErrorMsg: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(updateProviderStatus.pending, (state) => {
        state.isProviderStatusLoading = true;
        state.providerStatusError = null;
      })
      .addCase(updateProviderStatus.fulfilled, (state, action) => {
        if (!action.payload.success) {
          state.isProviderStatusLoading = false;
          state.providerStatusMsg = getApiErrorMessage(action.payload.success);
        } else {
          state.isProviderStatusLoading = false;
          state.providerStatusUpdateData = action.payload.data.data;
        }
      })
      .addCase(updateProviderStatus.rejected, (state, action) => {
        state.isProviderStatusLoading = false;
        state.providerStatusError = action.error.message;
      });
    builder
      .addCase(providerDuplicateCheck.pending, (state) => {
        state.isDuplicateCheckLoading = true;
        state.isDuplicateCheckError = null;
      })
      .addCase(providerDuplicateCheck.fulfilled, (state, action) => {
        if (!action.payload.success) {
          state.isDuplicateCheckLoading = false;
          state.isDuplicateErrorMsg = getApiErrorMessage(action.payload.success);
        } else {
          state.isDuplicateCheckLoading = false;
          state.isDuplicateCheckData = action.payload.data.data;
        }
      })
      .addCase(providerDuplicateCheck.rejected, (state, action) => {
        state.isDuplicateCheckLoading = false;
        state.isDuplicateCheckError = action.error.message;
      });
  },
});

export const providerStatusReducers = providerStatus.reducer;
export const providerStatusUpdateReducers = providerStatusUpdate.reducer;
